import PropTypes from 'prop-types'
import { PriceSheetCsvUploadErrors } from 'utils/constants'
import FormModalHeading from 'components/generic/modals/form-modal/FormModalHeading'
import { Box, Divider, Stack, Button, SwipeableDrawer, Typography } from '@mui/material_modern'
import Table from '@mui/material_modern/Table'
import TableBody from '@mui/material_modern/TableBody'
import TableCell from '@mui/material_modern/TableCell'
import TableContainer from '@mui/material_modern/TableContainer'
import TableHead from '@mui/material_modern/TableHead'
import TableRow from '@mui/material_modern/TableRow'

const errorsTable = data => (
  <TableContainer>
    <Table aria-label="A table with errors on the upload process">
      <TableHead>
        <TableRow>
          <TableCell>Error</TableCell>
          <TableCell>Location in file</TableCell>
          <TableCell>Code</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map(err => (
          <TableRow key={`row-${err.line}-${err.type}`}>
            <TableCell>{PriceSheetCsvUploadErrors[err.type]}</TableCell>
            <TableCell>Row {err.line}</TableCell>
            <TableCell>{err.type}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)

const footerContent = (onRetryUpload, onClose) => (
  <Stack direction="row" spacing={1}>
    <Button variant="contained" onClick={onRetryUpload}>
      Select new file
    </Button>
    <Button variant="outlined" onClick={onClose}>
      Close
    </Button>
  </Stack>
)

const PriceListUploadErrorsBlade = ({ open, onRetryUpload, onClose, errorsList }) => (
  <SwipeableDrawer
    anchor="right"
    open={open}
    onClose={() => {}}
    onOpen={() => {}}
    disableSwipeToOpen
    PaperProps={{ sx: { maxWidth: '1024px', width: '100%' } }}
  >
    <Stack divider={<Divider />} height="100vh">
      <FormModalHeading title="Price List Upload Results" backButtonPosition="right" onBack={onClose} />
      <Box flexGrow={1} padding={4}>
        <Typography>
          The following errors occurred during your price list upload. Click &ldquo;Select New File&rdquo; to upload
          your fixed file and try the upload again.
        </Typography>
        {errorsTable(errorsList)}
      </Box>
      <Stack
        direction="row"
        p={2}
        spacing={2}
        sx={{
          boxShadow:
            '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.5)',
        }}
      >
        {footerContent(onRetryUpload, onClose)}
      </Stack>
    </Stack>
  </SwipeableDrawer>
)

PriceListUploadErrorsBlade.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRetryUpload: PropTypes.func.isRequired,
  errorsList: PropTypes.array.isRequired,
}

PriceListUploadErrorsBlade.defaultProps = {}

export default PriceListUploadErrorsBlade
